import React, { useState } from 'react';

const CopyButton = ({ value, className = '' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    } catch (error) {
      console.error('Failed to copy text:', error);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleCopy();
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      onKeyDown={handleKeyDown}
      className={`ml-2 bg-transparent border-none cursor-pointer text-xl transition-colors duration-200 ${className}`}
      title={copied ? 'Copied!' : 'Copy'}
      aria-label={copied ? 'Text copied to clipboard' : 'Copy text to clipboard'}
      tabIndex={0}
    >
      {copied ? '✔️' : '📋'}
    </button>
  );
};

export default CopyButton; 